import { useState, useEffect } from "react";
import { apiFetch } from "../api";

const DEFAULTS = {
  whatsapp: "+20 100 000 0000",
  phone: "+20 2 1234 5678",
  email: "info@statia.com",
  office: "New Cairo, Egypt",
};

// Module-level cache so the API is hit once per page load across all components
let _cache = null;
let _promise = null;

export default function useSiteSettings() {
  const [settings, setSettings] = useState(_cache || DEFAULTS);

  useEffect(() => {
    if (_cache) return;
    if (!_promise) {
      _promise = apiFetch("/api/settings/contact").catch(() => null);
    }
    _promise.then((data) => {
      if (data) {
        _cache = data;
        setSettings(data);
      }
    });
  }, []);

  return settings;
}

export function invalidateSiteSettingsCache() {
  _cache = null;
  _promise = null;
}
